// extracted by mini-css-extract-plugin
module.exports = {"textbox":"_3vE1-"};